import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";

class AuditPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      upsertUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.findObjectUseCase = findObjectUseCase;
  }

  async componentDidMount() {
    const selectedClient = this.view.getSelectedClient();
    if (!selectedClient) {
      await this.getClient();
    }

    // const selectedClient = await this.getClients();
    await this.init();
    this.createQuery();
    await this.findObjects();
  }

  async init() {
    const { year } = this.view.state;
    const collectionName = this.view.getCollectionName();
    const selectedClient = this.view.getSelectedClient();

    const client = selectedClient;
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    const gte = startDate.toISOString();
    const lte = endDate.toISOString();
    this.limit = 10000;

    if (collectionName === "sales") {
      this.where = {
        date: {
          $gte: gte,
          $lte: lte,
        },
        creator: { id: selectedClient?.user?.id },
        isVatable: true,
      };
    } else {
      this.where = {
        date: {
          $gte: gte,
          $lte: lte,
        },
        client: {
          id: selectedClient?.id,
        },
        status: {
          $ne: "non-vat",
        },
      };
    }

    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getUserByClientId(clientId) {
    if (!clientId) return null;
    const collection = "users";
    const query = {
      where: {
        client: { id: clientId },
      },
    };
    try {
      const result = await this.findObjectUseCase.execute(collection, query);
      const user = Array.isArray(result) ? result[0] : result;
      return user ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async onChangeClient() {
    await this.init();
    this.createQuery();
    await this.findObjects();
  }

  getMonths() {
    const year = new Date().getFullYear();

    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  async getClient() {
    const collection = "clients";
    const user = this.view.getCurrentUser();
    const storageKey = this.view.getStorageKey();

    const query = {
      where: {
        $and: [
          { creator: { id: user?.id } },
          { clientOf: "admin" },
          { isActive: true },
        ],
      },
      keys: ["id", "name", "billingCity", "user"],
      limit: 1,
    };

    try {
      this.view.showClientProgress();
      const clients = await this.findObjectUseCase.execute(collection, query);

      const selectedClient = clients[0];
      sessionStorage.setItem(storageKey, JSON.stringify(selectedClient));

      this.view.hideClientProgress();
      return selectedClient ? { ...selectedClient } : {};
    } catch (error) {
      console.error(error);
      this.view.hideClientProgress();
      this.view.showError(error);
      return undefined;
    } finally {
      this.view.hideClientProgress();
    }
  }

  async getUserCient() {
    const collection = "users";
    const clientId = this.view.getClientId();
    const query = {
      where: {
        client: { id: clientId },
      },
    };

    try {
      this.view.showProgress();
      const user = await this.findObjectUseCase.execute(collection, query);
      return user[0];
    } catch (error) {
      this.view.showError(error);
      this.view.hideProgress();
    }
  }
}

export default AuditPagePresenter;
